import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import camelCase from 'lodash/camelCase';
export const getInstallableWidgets = (widgetConfigs, installableModules)=>{
    return installableModules.map((module)=>{
        const { moduleName } = module;
        const widgetConfig = widgetConfigs[camelCase(moduleName)];
        if (!widgetConfig) {
            return null;
        }
        const { widgetCard } = widgetConfig;
        return {
            module,
            widgetCard
        };
    }).filter(Boolean);
};
export const filterAlreadyInstalledAndCoreRestrictedModules = (installableModules, installedModules)=>{
    const installedModuleCounts = installedModules.reduce((acc, module)=>_object_spread_props(_object_spread({}, acc), {
            [module.name]: (acc[module.name] || 0) + 1
        }), {});
    return installableModules.map((module)=>{
        const { restrict, moduleName, limit } = module;
        if (restrict && restrict.permitted === false) {
            return null;
        }
        var _installedModuleCounts_moduleName;
        const installedCount = (_installedModuleCounts_moduleName = installedModuleCounts[moduleName]) !== null && _installedModuleCounts_moduleName !== void 0 ? _installedModuleCounts_moduleName : 0;
        if (installedCount >= limit) {
            return null;
        }
        return module;
    }).filter(Boolean);
};

//# sourceMappingURL=utils.js.map